import { Component, OnInit } from '@angular/core';
import { Routes, RouterModule, ChildrenOutletContexts } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
objusr:any={};
clcd="";
  constructor() { }

  ngOnInit(): void {
    this.objusr.usrname=localStorage.getItem('usrname');
    this.objusr.class=localStorage.getItem('class');
    this.objusr.crnm=localStorage.getItem('crnm');
    this.clcd=localStorage.getItem('clcd');
  }

}
